import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { IconCheck } from '../icon';
import { Markdown } from '../markdown';
import { styled } from '../styled';
import { Typography } from '../typography';
import { withVersion } from '../utils';
export const UpgradePageRoot = withVersion(styled(FlexBox)(({ theme }) => ({
    width: '100%',
    maxWidth: 1_760,
    boxSizing: 'border-box',
    margin: '0 auto',
    padding: theme.spacing(4, 6),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2)
    }
})), '1.0.0');
export const UpgradeHero = withVersion(styled(FlexBox)(({ theme }) => ({
    boxSizing: 'border-box',
    padding: theme.spacing(6, 8),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    gap: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(4),
        gap: theme.spacing(3),
        flexDirection: 'column',
        alignItems: 'stretch'
    }
})), '1.0.0');
export const UpgradeHeroAction = withVersion(styled(FlexBox)(({ theme }) => ({
    flexShrink: 0,
    alignSelf: 'center',
    '& button': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.contrastText,
            filter: 'brightness(0.95)'
        }
    },
    [theme.breakpoints.down('md')]: {
        alignSelf: 'flex-start'
    }
})), '1.0.0');
const UpgradePageImpl = ({ children, heroDescription, heroTitle, headline, bodyText, benefitsIntroText, bulletHeadline, bulletPoints, className, 'data-role': dataRole, 'data-role-value': dataRoleValue }) => {
    const hasBody = Boolean(bodyText || bulletHeadline || bulletPoints?.length);
    return (_jsxs(UpgradePageRoot, { className: className, stack: true, gap: 2, "data-role": dataRole, "data-role-value": dataRoleValue, children: [_jsxs(UpgradeHero, { stack: false, vAlign: "center", "data-role": dataRole ? `${dataRole}-hero` : undefined, children: [_jsxs(FlexBox, { stack: true, stretch: true, minWidth: 0, gap: 2, children: [_jsx(Typography, { variant: "headingLarge", color: "inherit", children: heroTitle }), _jsx(Typography, { color: "inherit", children: heroDescription })] }), children && _jsx(UpgradeHeroAction, { children: children })] }), hasBody && (_jsxs(FlexBox, { stack: true, padding: [0, 0.5], gap: 3, children: [headline && (_jsx(Typography, { variant: "headingLarge", children: headline })), bodyText && _jsx(Typography, { children: bodyText }), bulletHeadline && (_jsx(Typography, { variant: "headingLarge", children: bulletHeadline })), benefitsIntroText && (_jsx(Typography, { color: "text.secondary", maxWidth: 1_300, children: benefitsIntroText })), bulletPoints?.length ? (_jsx(FlexBox, { stack: true, gap: 1.5, children: bulletPoints.map((bullet) => (_jsxs(FlexBox, { gap: 1.5, vAlign: "center", minWidth: 0, children: [_jsx(IconCheck, { color: "success" }), _jsx(Markdown, { children: bullet })] }, bullet))) })) : null, children && (_jsx(FlexBox, { hAlign: "center", width: "100%", children: children }))] }))] }));
};
UpgradePageImpl.displayName = 'UpgradePage';
export const UpgradePage = withVersion(UpgradePageImpl, '1.0.0');
